export default __webpack_public_path__ + "static/accordion-closed-mobile-132ca2ea5b3cf0fc9c380168b1195a14.png";